import { createApiAction } from '@app/packages/api/utils'
import type { ApiEmailToken } from '@app/packages/api/v2/types/entities'

export const postEmailTokens = (email: string, cause?: string) =>
  createApiAction('postEmailTokens', dispatch => dispatch<void>({ method: 'POST', endpoint: '/api/v2/email_tokens', body: JSON.stringify({ email, cause }) }))

export const postEmailTokensVerify = (email: string, token: string) =>
  createApiAction('postEmailTokensVerify', dispatch =>
    dispatch<{ data: ApiEmailToken }>({ method: 'POST', endpoint: '/api/v2/email_tokens/verify', body: JSON.stringify({ email, token }) })
  )
